<app-popup>
  <div class="inner">
    <span class="default-cross" (click)="onClose()"></span>
    <div class="title">{{data?.action}}</div>
    <div class="content align-block">
      <div class="content-wrapper">
    <span class="lnr lnr-warning vertical-align" *ngIf="data?.type === 'delete'">
    </span>
        <span class="error-message-text"> {{data?.message}}</span>
      </div>
    </div>
    <div class="buttons-wrapper" *ngIf="!data?.disableClose">
      <button class="button blue-btn" (click)="onClose()">Отмена</button>
      <button *ngIf="data.recreateUser" class="button red-btn" (click)="onSuccess(false)">Создать нового</button>
      <button class="button red-btn" (click)="onSuccess(true)">
        {{data.action === 'Запросить отмену путешествия' ? 'Отправить запрос' : 'Да'}}
      </button>
    </div>
  </div>
</app-popup>
